"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const scale_1 = require("../../../utils/scale");
const TabArticles_1 = __importDefault(require("./TabArticles"));
const TabDashboard_1 = __importDefault(require("./TabDashboard"));
const TabHistory_1 = __importDefault(require("./TabHistory"));
const TabTimeline_1 = __importDefault(require("./TabTimeline"));
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const tabs = ['ダッシュボード', '記事', '自分史', 'タイムライン'];
const keyExtractor = (_, index) => `${index}`;
const TabBar = (props) => {
    const { userId, userNickname, publicHashtags, privateHashtags, isMyProfile, isFollowed } = props;
    const [currentTab, setCurrentTab] = (0, react_1.useState)(0);
    const refFlatList = (0, react_1.createRef)();
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const renderItem = ({ item, index }) => {
        const isActive = currentTab == index;
        const onTabPress = () => {
            // refFlatList.current?.scrollToIndex({ animated: true, index, viewPosition: 0.5 })
            setCurrentTab(index);
        };
        return (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.TouchableOpacity, { key: index, style: styles.tabItem, onPress: onTabPress },
                react_1.default.createElement(CustomText_1.default, { weight: isActive ? '600' : '300', style: [styles.tabItemText, isActive && { color: '#007AFF' }] }, item)),
            react_1.default.createElement(react_native_1.View, { style: isActive ? styles.lineActive : styles.line })));
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        react_1.default.createElement(react_native_1.FlatList, { style: {}, ref: refFlatList, data: tabs, horizontal: true, keyExtractor: keyExtractor, renderItem: renderItem, contentContainerStyle: styles.contentContainer, showsHorizontalScrollIndicator: false, ListFooterComponent: () => react_1.default.createElement(react_native_1.View, { style: styles.line }) }),
        react_1.default.createElement(react_native_1.View, { style: styles.tabContents },
            react_1.default.createElement(TabDashboard_1.default, { isActive: currentTab == 0, publicHashtags: publicHashtags, privateHashtags: privateHashtags, isMyProfile: isMyProfile }),
            react_1.default.createElement(TabArticles_1.default, { userId: userId, userNickname: userNickname, isActive: currentTab == 1, isMyProfile: isMyProfile }),
            react_1.default.createElement(TabHistory_1.default, { userId: userId, userNickname: userNickname, isActive: currentTab == 2, isMyProfile: isMyProfile }),
            react_1.default.createElement(TabTimeline_1.default, { userId: userId, isActive: currentTab == 3, isPublicOnly: !isMyProfile && !isFollowed, isMyProfile: isMyProfile }))));
};
exports.default = TabBar;
const styles = react_native_1.StyleSheet.create({
    container: {
        width: '100%',
        marginTop: (0, scale_1.scale)(32),
    },
    contentContainer: {
        paddingHorizontal: (0, scale_1.scale)(16),
    },
    tabItem: {
        paddingBottom: (0, scale_1.scale)(8),
        paddingHorizontal: (0, scale_1.scale)(16),
    },
    tabItemText: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#888888'
    },
    line: {
        width: '100%',
        height: (0, scale_1.scale)(4),
        backgroundColor: '#DDDDDD'
    },
    lineActive: {
        width: '100%',
        height: (0, scale_1.scale)(4),
        borderRadius: 999,
        backgroundColor: '#007AFF'
    },
    tabContents: {
        width: '100%',
        marginTop: (0, scale_1.scale)(12)
    }
});
